import { useState, useEffect, useCallback } from 'react';
import { userNameStorageService } from '@/services/userNameStorageService';

interface UseUserNameReturn {
  userName: string;
  setUserName: (name: string) => void;
  clearUserName: () => void;
  isStorageAvailable: boolean;
}

export const useUserName = (): UseUserNameReturn => {
  const [userName, setUserNameState] = useState<string>('');

  // Initialize userName from storage on mount
  useEffect(() => {
    const storedName = userNameStorageService.getUserName();
    if (storedName) {
      setUserNameState(storedName);
    }
  }, []);

  // Update userName and persist to storage
  const setUserName = useCallback((name: string) => {
    setUserNameState(name);
    
    // Let the storage service handle trimming
    if (name.trim()) {
      userNameStorageService.setUserName(name);
    }
  }, []);

  // Clear userName from state and storage
  const clearUserName = useCallback(() => {
    setUserNameState('');
    userNameStorageService.clearAllData();
  }, []);

  // Check if storage is available
  const isStorageAvailable = userNameStorageService.isStorageAvailable();

  return {
    userName,
    setUserName,
    clearUserName,
    isStorageAvailable
  };
}; 